/*! cart-drawer.js (Prestige-style — Terms gating) — 2025-09-08 */
(function () {
  function init() {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;

    const overlay = drawer.querySelector('[data-drawer-overlay]');
    let body = drawer.querySelector('[data-drawer-body]');
    const panel = drawer.querySelector('.cart-drawer__panel');
    const sectionId = drawer.dataset.sectionId || 'cart-drawer';
    const sectionHandle = drawer.dataset.sectionHandle || 'cart-drawer';
    const OPEN_CLASS = 'is-open';
    const __lock = { y: 0, bodyPR: '' };

function getScrollbarWidth() {
  return Math.max(0, window.innerWidth - document.documentElement.clientWidth);
}

    /* ---------- helpers ---------- */
function lockScroll(lock) {
  const sbw = window.innerWidth - document.documentElement.clientWidth; // scrollbar width
  document.documentElement.style.overflow = lock ? 'hidden' : '';
  document.body.style.overflow = lock ? 'hidden' : '';
  document.body.style.paddingRight = lock ? `${sbw}px` : '';
  document.body.classList.toggle('has-modal-open', !!lock);

  // ryd evt. efterladt tema-klasse
  if (!lock) document.body.classList.remove('cc-popup-no-scroll-pad-right');
}


    /* ---------- open/close ---------- */
    function openDrawer() {
      drawer.setAttribute('aria-hidden', 'false');
      drawer.classList.add(OPEN_CLASS);
      // Fallback: vis panelet selv hvis CSS er overstyret
      try { panel.style.transform = 'translateX(0)'; } catch (_) {}
      try { overlay.style.opacity = '1'; } catch (_) {}
      lockScroll(true);
      try { panel.focus(); } catch (_) {}
      // sync terms state on open
      updateTermsUI();
    }

    function closeDrawer() {
      drawer.setAttribute('aria-hidden', 'true');
      drawer.classList.remove(OPEN_CLASS);
      try { panel.style.transform = 'translateX(100%)'; } catch (_) {}
      try { overlay.style.opacity = ''; } catch (_) {}
      lockScroll(false);
    }

    /* ---------- click interception (før temaets handlers) ---------- */
    document.addEventListener('click', function (e) {
      const toggle = e.target.closest('[data-cart-toggle], a[href$="/cart"], a[href*="/cart?"]');
      if (toggle && !toggle.closest('#CartDrawer')) {
        e.preventDefault();
        e.stopImmediatePropagation();
        openDrawer();
        return false;
      }
      if (e.target.closest('[data-drawer-close]') || e.target === overlay) {
        e.preventDefault();
        e.stopImmediatePropagation();
        closeDrawer();
        return false;
      }
    }, { capture: true });

    /* ---------- esc to close ---------- */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains(OPEN_CLASS)) closeDrawer();
    });

    /* ---------- RENDER (Section Rendering API) ---------- */
    async function renderDrawer() {
      const urls = [
        `${window.location.pathname}?sections=${encodeURIComponent(sectionId)}`,
        `${window.location.pathname}?sections=${encodeURIComponent(sectionHandle)}`
      ];
      let htmlMap = null;
      for (const url of urls) {
        try {
          const res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
          if (!res.ok) continue;
          htmlMap = await res.json();
          if (htmlMap && (htmlMap[sectionId] || htmlMap[sectionHandle])) break;
        } catch (_) {}
      }
      if (!htmlMap) return;

      const newHTML = htmlMap[sectionId] || htmlMap[sectionHandle];
      const tmp = document.createElement('div');
      tmp.innerHTML = newHTML;
      const newBody = tmp.querySelector('[data-drawer-body]');
      if (newBody) {
        body.replaceWith(newBody);
        body = newBody;
        wireTermsUI();   // rebind terms controls on fresh DOM
        updateTermsUI(); // reflect state
      }

      // Opdater badge i headeren
      try {
        const cart = await (await fetch('/cart.js')).json();
        const bubble = document.querySelector('[data-cart-count]');
        if (bubble) bubble.textContent = cart.item_count;
      } catch (_) {}
    }

    /* ---------- ADD TO CART interception ---------- */
    document.addEventListener('submit', async function (e) {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      const action = form.getAttribute('action') || form.action || '';
      if (!action.includes('/cart/add')) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      const formData = new FormData(form);
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        });
        if (res.ok) {
          await renderDrawer();
          openDrawer();
        } else {
          const err = await res.json().catch(() => ({}));
          alert(err?.description || 'Kunne ikke lægge i kurven.');
        }
      } catch (err) {
        console.error(err);
      }
    }, { capture: true });

    /* ---------- Qty +/- & remove inside drawer ---------- */
    drawer.addEventListener('click', async function (e) {
      const btn = e.target.closest('[data-qty-plus], [data-qty-minus], [data-remove-line]');
      if (!btn) return;
      const itemEl = btn.closest('.cart-drawer__item');
      if (!itemEl) return;
      const line = Number(itemEl.dataset.line);

      if (btn.hasAttribute('data-qty-plus') || btn.hasAttribute('data-qty-minus')) {
        const input = itemEl.querySelector('.qty-input');
        let q = parseInt((input && input.value) || '1', 10);
        q = btn.hasAttribute('data-qty-plus') ? q + 1 : Math.max(0, q - 1);
        await changeLine(line, q);
      }
      if (btn.hasAttribute('data-remove-line')) {
        await changeLine(line, 0);
      }
    });

    async function changeLine(line, quantity) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line, quantity })
      });
      await renderDrawer();
    }

    /* ================= TERMS & CONDITIONS ================= */
    function getTermsCheckbox() { return drawer.querySelector('#CartTerms'); }
    function getTermsError()    { return drawer.querySelector('[data-terms-error]'); }
    function getCheckoutBtns()  { return drawer.querySelectorAll('[data-checkout], [name="checkout"]'); }

    function setCheckoutEnabled(enabled){
      getCheckoutBtns().forEach(btn => {
        if (!btn) return;
        if (enabled){
          btn.removeAttribute('disabled');
          btn.setAttribute('aria-disabled', 'false');
          btn.classList.remove('is-disabled');
        } else {
          btn.setAttribute('disabled', 'disabled');
          btn.setAttribute('aria-disabled', 'true');
          btn.classList.add('is-disabled');
        }
      });
    }

    function updateTermsUI(){
      const cb = getTermsCheckbox();
      const err = getTermsError();
      const checked = !!(cb && cb.checked);
      setCheckoutEnabled(checked);
      if (err) {
        if (checked){ err.hidden = true; }
        // do not unhide on update; only show on violation
      }
    }

    function wireTermsUI(){
      const cb = getTermsCheckbox();
      const err = getTermsError();

      // On change -> enable/disable
      if (cb) {
        cb.addEventListener('change', () => {
          setCheckoutEnabled(cb.checked);
          if (cb.checked && err) err.hidden = true;
        });
      }

      // Gate checkout clicks
      drawer.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-checkout], [name="checkout"]');
        if (!btn) return;
        const ok = !!(getTermsCheckbox() && getTermsCheckbox().checked);
        if (!ok){
          e.preventDefault(); e.stopImmediatePropagation();
          // show error, focus checkbox
          if (err) { err.hidden = false; err.textContent = 'Du skal acceptere handelsbetingelserne for at fortsætte.'; }
          if (cb)  { cb.focus(); }
        }
      });

      // Also gate form submit from the drawer form
      const form = drawer.querySelector('[data-cart-form]');
      if (form){
        form.addEventListener('submit', (e) => {
          // Only intercept if submitter is checkout button
          const sub = e.submitter;
          const isCheckout = sub && (sub.matches('[data-checkout]') || sub.name === 'checkout');
          if (!isCheckout) return;
          const ok = !!(getTermsCheckbox() && getTermsCheckbox().checked);
          if (!ok){
            e.preventDefault(); e.stopImmediatePropagation();
            if (err) { err.hidden = false; err.textContent = 'Du skal acceptere handelsbetingelserne for at fortsætte.'; }
            const cb = getTermsCheckbox(); if (cb) cb.focus();
          }
        });
      }
    }

    // initial bind
    wireTermsUI();
    updateTermsUI();

    /* ---------- test helpers ---------- */
    window.CartDrawerTest = {
      ping: () => 'ok',
      open: openDrawer,
      close: closeDrawer,
      render: renderDrawer
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
